import React from 'react'
import styled from 'styled-components'
import { rightToLeftStyles } from 'utils/rtlTextUtil'

const StyledRtlTextContainer = styled.div`
  ${rightToLeftStyles}
  width: inherit;
`

type DirectionContentComponentProps = {
  isRtl?: boolean
  children: React.ReactElement
}

const DirectionContentComponent = ({ isRtl, children }: DirectionContentComponentProps) =>
  isRtl ? <StyledRtlTextContainer>{children}</StyledRtlTextContainer> : children

export default DirectionContentComponent
